import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import cowonderMiniLogo from '@/assets/cowonderminilogo.png';

const cols = [
  { title: 'Produto', links: ['Gestão Fiscal', 'Dashboard', 'CRM', 'Preços'] },
  { title: 'Empresa', links: ['Sobre Nós', 'Carreiras', 'Blog', 'Contato'] },
  { title: 'Suporte', links: ['Central de Ajuda', 'Documentação', 'FAQ', 'Segurança'] },
];

const socials = [
  { icon: <LinkedInIcon sx={{ fontSize: 18 }} />, label: 'LinkedIn' },
  { icon: <TwitterIcon sx={{ fontSize: 18 }} />, label: 'Twitter' },
  { icon: <FacebookIcon sx={{ fontSize: 18 }} />, label: 'Facebook' },
  { icon: <InstagramIcon sx={{ fontSize: 18 }} />, label: 'Instagram' },
];

function Footer() {
  return (
    <footer className="bg-[#0f0a1a] text-white/60 text-sm">
      <div className="max-w-6xl mx-auto px-8 pt-16 pb-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[auto_1fr_1fr_1fr] gap-12">
        <div className="flex flex-col gap-3 max-w-[200px]">
          <div className="flex items-center gap-2">
            <img src={cowonderMiniLogo} alt="" className="w-7 h-7 brightness-0 invert" />
            <span className="text-white font-bold text-base tracking-tight">Cowonder</span>
          </div>
          <p className="text-white/40 text-xs leading-relaxed">
            A solução completa para gestão inteligente do seu negócio.
          </p>
        </div>

        {cols.map((col) => (
          <div key={col.title} className="flex flex-col gap-3">
            <h4 className="text-white font-semibold text-sm mb-1">{col.title}</h4>
            {col.links.map((link) => (
              <a key={link} href="#" className="text-white/50 hover:text-[#CB88F9] transition-colors text-sm">
                {link}
              </a>
            ))}
          </div>
        ))}
      </div>

      <div className="border-t border-white/[0.06] max-w-6xl mx-auto px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-4">
        <p className="text-white/30 text-xs">
           © {new Date().getFullYear()} Cowonder. Todos os direitos reservados.
        </p>
        <div className="flex items-center gap-3">
          {socials.map(({ icon, label }) => (
            <a key={label} href="#" aria-label={label} className="text-white/40 hover:text-[#CB88F9] transition-colors">
              {icon}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
